// extracted by mini-css-extract-plugin
module.exports = {"missonData":"A_PraSD0nxGrlBkgV-yFP","heading":"_3pDqT4vAITe7Q7Ta-Zyegg","line":"_2idR9Xi6e3jsDzVEv8aMi1","detailsContainer":"N19KTO4P1jLyMcxfZmDNQ","key":"IEZuJexO99NCJV8fksytX"};